
<template>
	<div class="sys">
		<van-nav-bar @click-left="onClickLeft" :safe-area-inset-top="true" title="扫一扫" left-arrow :placeholder="true"
			:fixed="true"></van-nav-bar>
		<BarScan @ok="getResult" @err="geterror" ></BarScan>
	</div>
</template>
 
<script>
	import BarScan from '@/components/qrcode-reader.vue'
    import {Dialog} from 'vant';
	export default {
		components:{
			BarScan
		},
		data() {
			return {
				result:''
			}
		},
		created() {
		},
		methods:{
			onClickLeft(){
				this.$router.go(-1);
			},
            //成功之后的回调
			getResult(result){
                console.log(result)
			    this.result=result;
			},
			geterror(e){
				this.scancode=false;
				Dialog.alert({title: '提示', message:e})
			},
		}
	}
</script>
 
<style>
	.sys{
		width: 100vw;
		height: 100vh;
		background: #111;
	}
</style>